import { api } from "@/lib/api";

export interface ChecklistItem {
	id: string;
	task_id: string;
	title: string;
	is_completed: boolean;
	position: number;
	attachment_count: number;
	created_by: string | null;
	created_at: string;
	updated_at: string;
}

export interface ChecklistTemplate {
	id: string;
	project_id: string | null;
	name: string;
	items: { title: string }[];
	created_by: string | null;
	created_at: string;
	updated_at: string;
}

export interface ChecklistItemPatch {
	title?: string;
	is_completed?: boolean;
	position?: number;
}

export async function listChecklistItems(
	projectId: string,
	taskId: string,
): Promise<ChecklistItem[]> {
	const res = await api.get<{ data: ChecklistItem[] }>(
		`/projects/${projectId}/tasks/${taskId}/checklist-items`,
	);
	return res.data;
}

export async function createChecklistItem(
	projectId: string,
	taskId: string,
	title: string,
): Promise<ChecklistItem> {
	const res = await api.post<{ data: ChecklistItem }>(
		`/projects/${projectId}/tasks/${taskId}/checklist-items`,
		{ title },
	);
	return res.data;
}

export async function updateChecklistItem(
	projectId: string,
	taskId: string,
	itemId: string,
	patch: ChecklistItemPatch,
): Promise<ChecklistItem> {
	const res = await api.patch<{ data: ChecklistItem }>(
		`/projects/${projectId}/tasks/${taskId}/checklist-items/${itemId}`,
		patch,
	);
	return res.data;
}

export async function deleteChecklistItem(
	projectId: string,
	taskId: string,
	itemId: string,
): Promise<void> {
	await api.delete(
		`/projects/${projectId}/tasks/${taskId}/checklist-items/${itemId}`,
	);
}

export async function applyChecklistTemplate(
	projectId: string,
	taskId: string,
	templateId: string,
): Promise<ChecklistItem[]> {
	const res = await api.post<{ data: ChecklistItem[] }>(
		`/projects/${projectId}/tasks/${taskId}/checklist-items/apply-template`,
		{ template_id: templateId },
	);
	return res.data;
}

export async function listChecklistTemplates(
	projectId: string,
): Promise<ChecklistTemplate[]> {
	const res = await api.get<{ data: ChecklistTemplate[] }>(
		`/projects/${projectId}/checklist-templates`,
	);
	return res.data;
}

export async function createChecklistTemplate(
	projectId: string,
	name: string,
	items: { title: string }[],
): Promise<ChecklistTemplate> {
	const res = await api.post<{ data: ChecklistTemplate }>(
		`/projects/${projectId}/checklist-templates`,
		{ name, items },
	);
	return res.data;
}

export async function updateChecklistTemplate(
	projectId: string,
	templateId: string,
	name: string,
	items: { title: string }[],
): Promise<ChecklistTemplate> {
	const res = await api.patch<{ data: ChecklistTemplate }>(
		`/projects/${projectId}/checklist-templates/${templateId}`,
		{ name, items },
	);
	return res.data;
}

export async function deleteChecklistTemplate(
	projectId: string,
	templateId: string,
): Promise<void> {
	await api.delete(
		`/projects/${projectId}/checklist-templates/${templateId}`,
	);
}
